import { PaymentRequestNotificationData } from "@cruisen/contract"
import styles from "./styles.module.scss"
import SuccessCheckImage from "../../../../assets/successCheck.png"

export const UserApprovedPaymentRequestMessage = ({
  data,
  openPaymentRequestDetails,
}: {
  data: PaymentRequestNotificationData
  openPaymentRequestDetails: () => void
}) => {
  return (
    <div className={styles.approvedPaymentRequest} data-testid="approved-quote-message">
      <div className={styles.header}>
        <img className={styles.headerImage} src={SuccessCheckImage} alt="Approved quote" />
      </div>
      <div className={styles.body}>
        <p className={styles.title}>Quote request “{data.quoteName}” was approved</p>
        <div className={styles.divider}></div>
        <p className={styles.description}>
          <span className={styles.user}>
            {data.userFirstName} {data.userLastNameInitial}.
          </span>{" "}
          approved payment for the quote "{data.quoteName}" on the trip "{data.tripName}".
        </p>
        <button className={styles.viewDetailsButton} onClick={openPaymentRequestDetails}>
          View details
        </button>
      </div>
    </div>
  )
}
